export interface CheckoutPurchase {
  currencyCode: string;
  date: string;
  price: number;
  retailer: string;
}
